import "~/css/redesign-v1/tokens.css";
import "./base.css";
// import "./adaptive.css";
import "./fonts.css";

import React, { type ReactNode, useEffect } from "react";

import { cn } from "./cn";

export interface RedesignRootProps {
  children: ReactNode;
  className?: string;
  as?: "div" | "main" | "section";
}

export function RedesignRoot({ children, className, as: Tag = "div" }: RedesignRootProps) {
  useEffect(() => {
    const html = document.documentElement;
    html.setAttribute("data-redesign-v1", "");
    return () => html.removeAttribute("data-redesign-v1");
  }, []);

  return (
    <Tag data-redesign-v1 className={cn("tw-min-h-full tw-bg-background tw-font-sans tw-text-foreground tw-antialiased", className)}>
      {children}
    </Tag>
  );
}
